import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import NowName from '../components/shared/NowName';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import { formatDateShort } from '../utils/dateFormat';

// Attendance disputes — list page (docs/modules/workflow-ld-dispute.md).
// Self-service: every logged-in user sees their own disputes; holders of
// ld:absence:review (shared with the absence flow) see all of them.
const WorkflowDispute = () => {
  const { hasPermission } = useAuth();
  const canReview = hasPermission('ld:absence:review');
  return (
    <WorkflowListShell
      title="Attendance Dispute"
      subtitle={canReview
        ? 'Attendance disputes to review.'
        : 'Your attendance disputes.'}
      newTo="/workflow/dispute/new"
      newLabel="New Declaration"
      canCreate
      apiPath="/api/ld/dispute-requests"
      searchPlaceholder="Search dispute / session / staff…"
      rowTo={(r) => `/workflow/dispute/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Dispute',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/dispute/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'staff', label: 'Staff', sortKey: 'staff', className: 'text-slate-700 whitespace-nowrap', render: (r) => <NowName value={r.staffName} now={r.staffNameNow} /> },
        { key: 'session', label: 'Session', sortKey: 'session', className: 'text-slate-900 max-w-xs truncate', cellTitle: (r) => r.sessionTitle, render: (r) => r.sessionTitle },
        { key: 'sessionDate', label: 'Session Date', sortKey: 'sessionDate', className: 'text-slate-700 whitespace-nowrap', render: (r) => (r.sessionDate ? formatDateShort(r.sessionDate) : '—') },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowDispute;
